// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"029d7945","210":"a6dbaef6","453":"a6a6e5f0","708":"8e37cd67","982":"b2787cad"}[chunkId] + ".chunk.js";
};